module.exports = __webpack_public_path__ + "krecove-zily_4_before.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/obecna-a-zilni-chirurgie/krecove-zily_4_before.jpg
// module id = 1032
// module chunks = 0